import React from "react";
import { Typography } from "@material-ui/core";
export default function EmptyItem() {
    return React.createElement(Typography, { variant: "subtitle1" }, "-");
}
